import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import classNames from "classnames";
import { __ } from "@jti/fe-common";
import { Info, Txt } from "@jti/ui";
import ArrowIcon from "@jti/ui/icons/arrow.svg";
import RewardIcon from "@jti/ui/icons/reward.svg";
import { useDispatch, useSelector } from "../../store";
import { referral } from "../../store/slices/referral";
import ReferralInputValidationResult from "./ReferralInputValidationResult";
import "./ReferralInput.scss";
const ReferralInput = ({ onChange, isValidated, errorMessage = "" }) => {
    const referralStore = useSelector((state) => state.referral);
    const dispatch = useDispatch();
    const referralCodeClassName = classNames("referral-input__input", {
        "referral-input__input--error": !isValidated && referralStore.voucher,
    });
    const rootClassName = classNames("referral-input", {
        "referral-input--open": referralStore.isOpen,
    });
    const onClick = () => {
        dispatch(referral.actions.saveOpenStatus(!referralStore.isOpen));
    };
    const dispatchVoucher = (voucher) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(voucher);
        dispatch(referral.actions.saveVoucher(voucher));
    };
    const onChangeEvent = ($event) => {
        const targetValue = $event.currentTarget.value.trim();
        dispatchVoucher(targetValue);
    };
    useEffect(() => {
        if (referralStore.voucher) {
            dispatchVoucher(referralStore.voucher);
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: rootClassName, children: [_jsxs("div", { className: "referral-input__title", "data-testid": "referralInputTitle", onClick: onClick, children: [_jsx(RewardIcon, { className: "referral-input__gift-icon" }), _jsx(Txt, { variant: "field-label-2", children: __("auth.loyalty.haveReferralCode") }), _jsx(ArrowIcon, { className: "referral-input__arrow" })] }), _jsxs("div", { className: "referral-input__content", children: [_jsx("div", { className: "referral-input__content-desc", children: _jsx(Txt, { variant: "field-label-2", children: __("auth.loyalty.description") }) }), _jsxs("div", { className: "referral-input__input-container", children: [_jsx("label", { children: _jsx(Txt, { variant: "field-label-2", children: __("auth.loyalty.referralTitle") }) }), _jsx("input", { "data-testid": "referral-input", className: referralCodeClassName, placeholder: __("auth.loyalty.inputPlaceholder"), name: "referrer-code", onChange: onChangeEvent, value: referralStore.voucher })] }), _jsx("div", { className: "referral-input__input-desc", children: _jsx(Info, { message: __("auth.loyalty.inputDescription") }) })] })] }), _jsx(ReferralInputValidationResult, { message: errorMessage, code: !!referralStore.voucher, isValidated: isValidated })] }));
};
export default ReferralInput;
